import React from "react";
import { Form } from "react-bootstrap";

const TextInput = ({ formik, field }) => (
  <>
    <Form.Control
      id={field}
      name={field}
      disabled={formik.isSubmitting}
      value={formik.values[field]}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
    />
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default TextInput;
